import React from 'react'
import PropTypes from 'prop-types'

import s from './FooterColumnTitle.scss'


const FooterColumnTitle = ({ children }) => (
  <div className={s.title}>
    {children}
  </div>
)

FooterColumnTitle.propTypes = {
  children: PropTypes.node,
}


export default FooterColumnTitle
